module.exports = __webpack_public_path__ + "media/images/page/scene06-cb3be6bc34ae308031aeffed90177d1b.jpg";